import { useLang } from "../context/LanguageContext";
import { useAIAssistant } from "../context/AIAssistantContext";
import { FIKAMI, mailLink, waLink } from "../constants";

export const Contact = () => {
  const { t } = useLang();
  const { openAssistant } = useAIAssistant();

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-6">
            <div className="eyebrow">{t.contact.eyebrow}</div>
            <h2
              data-testid="contact-title"
              className="mt-5 font-[Outfit] text-4xl sm:text-5xl font-light text-white leading-[1.05] tracking-tight"
            >
              {t.contact.title}
            </h2>
            <p className="mt-5 text-lg text-zinc-400 leading-relaxed">
              {t.contact.subtitle}
            </p>

            <div className="mt-8">
              <button
                data-testid="contact-ai-cta"
                onClick={openAssistant}
                className="fk-btn fk-btn-primary"
              >
                <i className="fa-solid fa-wand-magic-sparkles" />
                {t.contact.ctaPrimary}
              </button>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="fk-glass rounded-2xl p-7">
              <div className="flex items-center justify-between mb-5">
                <span className="text-[11px] tracking-[0.28em] uppercase text-zinc-500">
                  {t.contact.secondaryNote}
                </span>
                <span className="inline-flex items-center gap-1.5 text-[11px] text-zinc-500">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
                  MX · US · CA
                </span>
              </div>

              <div className="space-y-4">
                <a
                  href={mailLink("New inquiry from fikamillc.com")}
                  data-testid="contact-email-row"
                  className="group flex items-center gap-4 p-3 -mx-3 rounded-xl hover:bg-white/[0.03] transition-colors"
                >
                  <span className="w-11 h-11 rounded-xl bg-[#FF5A00]/10 border border-[#FF5A00]/25 inline-flex items-center justify-center text-[#FF5A00]">
                    <i className="fa-solid fa-envelope" />
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="text-[10px] tracking-[0.28em] uppercase text-zinc-500">
                      {t.contact.emailLabel}
                    </div>
                    <div
                      data-testid="contact-email-address"
                      className="text-white font-medium truncate group-hover:text-[#FF5A00] transition-colors"
                    >
                      {FIKAMI.email}
                    </div>
                  </div>
                  <i className="fa-solid fa-arrow-up-right-from-square text-zinc-500 group-hover:text-[#FF5A00] transition-colors" />
                </a>

                <a
                  href={waLink(t.contact.waMessage)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-whatsapp-row"
                  className="group flex items-center gap-4 p-3 -mx-3 rounded-xl hover:bg-white/[0.03] transition-colors"
                >
                  <span className="w-11 h-11 rounded-xl bg-white/[0.04] border border-white/10 inline-flex items-center justify-center text-zinc-300">
                    <i className="fa-brands fa-whatsapp" />
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="text-[10px] tracking-[0.28em] uppercase text-zinc-500">
                      {t.contact.whatsappLabel}
                    </div>
                    <div
                      data-testid="contact-whatsapp-number"
                      className="text-white font-medium group-hover:text-[#FF5A00] transition-colors"
                    >
                      {FIKAMI.whatsappNumber}
                    </div>
                  </div>
                  <i className="fa-solid fa-arrow-up-right-from-square text-zinc-500 group-hover:text-[#FF5A00] transition-colors" />
                </a>

                <div className="flex items-center gap-4 p-3 -mx-3">
                  <span className="w-11 h-11 rounded-xl bg-white/[0.04] border border-white/10 inline-flex items-center justify-center text-zinc-300">
                    <i className="fa-solid fa-globe" />
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="text-[10px] tracking-[0.28em] uppercase text-zinc-500">
                      {t.contact.hoursLabel}
                    </div>
                    <div className="text-white font-medium">
                      {t.contact.hoursValue}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
